import { Box, Collapse, IconButton, Typography } from '@mui/material'
import { useState } from 'react'
import GoogleIcon from '../icon/GoogleIcon'
import {
  SECTION_COLLAPSE_CLOSE_ARIA_LABEL_PREFIX,
  SECTION_COLLAPSE_OPEN_ARIA_LABEL_PREFIX
} from '../constants/sectionCollapseConstants'
import { UI_COLOR_TEXT_PRIMARY, UI_COLOR_TEXT_SECONDARY } from '../constants/uiColors'

const SECTION_COLLAPSE_STYLES = {
  titleWeight: 700,
  titleColor: UI_COLOR_TEXT_PRIMARY,
  subtitleColor: UI_COLOR_TEXT_SECONDARY,
  toggleIconSize: 22
}

export default function SectionCollapse({
  title,
  icon = null,
  defaultOpen = true,
  children,
  type,
  contentSx = {},
  onToggle,
  ariaLabelOpen,
  ariaLabelClose
}) {
  const [open, setOpen] = useState(defaultOpen)

  const handleToggle = () => {
    const nextOpen = !open
    setOpen(nextOpen)
    onToggle?.(nextOpen)
  }

  return (
    <Box
      className={type == 'secondary' ? 'section-non-elevated' : 'section-elevated'}
      sx={{ mb: 2 }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          cursor: 'pointer'
        }}
        onClick={handleToggle}
      >
        <Box display="flex" alignItems="center" gap={1}>
          {icon}
          <Typography
            fontWeight={SECTION_COLLAPSE_STYLES.titleWeight}
            color={
              type == 'title'
                ? SECTION_COLLAPSE_STYLES.titleColor
                : SECTION_COLLAPSE_STYLES.subtitleColor
            }
          >
            {title}
          </Typography>
        </Box>
        <IconButton
          size="small"
          aria-label={
            open
              ? ariaLabelClose || `${SECTION_COLLAPSE_CLOSE_ARIA_LABEL_PREFIX} ${title}`
              : ariaLabelOpen || `${SECTION_COLLAPSE_OPEN_ARIA_LABEL_PREFIX} ${title}`
          }
          aria-expanded={open}
          onClick={(event) => {
            event.stopPropagation()
            handleToggle()
          }}
        >
          <GoogleIcon
            name={open ? 'expand_less' : 'expand_more'}
            size={SECTION_COLLAPSE_STYLES.toggleIconSize}
          />
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box px={2} pb={2} sx={contentSx}>
          {children}
        </Box>
      </Collapse>
    </Box>
  )
}
